import SecondaryButton from "./SecondaryButton";
import PrimaryButton from "./PrimaryButton";
import VerifiedSubmitButton from "./VerifiedSubmitButton";

const FormFooter = ({
  primaryCaption,
  secondaryCaption,
  secondaryClickHandler,
  primaryButtonColor = "blue",
  isLoading = false,
  loadingCaption = "Saving…",
  disabled = false,
  requiresVerification = false,
  verificationMessage,
}) => {
  const buttonClasses = `inline-flex justify-center rounded-pill border border-transparent px-4 py-2 text-sm font-medium text-white focus:outline-none focus:ring-2 focus:ring-offset-2 transition-colors ${
    primaryButtonColor === "blue"
      ? "bg-accent-500 hover:bg-accent-600 focus:ring-accent-500/30"
      : primaryButtonColor === "red"
      ? "bg-signal-red-500 hover:bg-signal-red-600 focus:ring-signal-red-500/30"
      : "bg-ink-700 hover:bg-ink-900 focus:ring-ink-500"
  } ${disabled || isLoading ? "opacity-50 cursor-not-allowed" : ""}`;

  return (
    <div className="mt-6 border-t border-ink-100 pt-6">
      <div className="flex items-center justify-end gap-x-4">
        {secondaryCaption && (
          <SecondaryButton
            onClick={secondaryClickHandler}
            colour="gray"
            disabled={isLoading}
          >
            {secondaryCaption}
          </SecondaryButton>
        )}
        {requiresVerification ? (
          <VerifiedSubmitButton
            type="submit"
            disabled={isLoading || disabled}
            className={buttonClasses}
            verificationMessage={verificationMessage}
          >
            {isLoading ? loadingCaption : primaryCaption}
          </VerifiedSubmitButton>
        ) : (
          <PrimaryButton
            colour={primaryButtonColor}
            type="submit"
            disabled={isLoading || disabled}
          >
            {isLoading ? loadingCaption : primaryCaption}
          </PrimaryButton>
        )}
      </div>
    </div>
  );
};

export default FormFooter;
